<template>
    <div
      class="text-sm-center main-header navbar navbar-expand navbar-light p-2 bg-light border-top"
      style="top:50px;"
    >
    
      <div class="form-group ml-3">
        <div
          id="reportrange"
          class="float-right"
          style="background: #fff; cursor: pointer; padding: 15px 10px; border: 1px solid #ccc; width: 100%"
        >
          <i class="fa fa-calendar"></i>&nbsp;
          <span>{{value}}</span>
          <i class="fa fa-caret-down"></i>
        </div>
      </div>
       <!-- <div class="form-group">        
        <multiselect
            label="title"
            :options="['Client', 'Device']"
            placeholder="Select Speaker"
            ></multiselect>
        </div> -->
    </div>
</template>

<script>

export default {

data(){
    return {
        value: 'Select Date',
        startDate:'',
        endDate:''
    }
},

methods:{

    cb(start, end) {
        this.startDate = start.format("YYYY-MM-DD")
        this.endDate = end.format("YYYY-MM-DD")

        this.value = start.format("D MMMM, YYYY") + " - " + end.format("D MMMM, YYYY")
        this.$emit('datepicker', this.startDate, this.endDate)
       
    },

    init(){

         var start = moment();
         var end = moment();

        $("#reportrange").daterangepicker(
            {
            startDate: start,
            endDate: end,
            ranges: {
                Today: [moment(), moment()],
                Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                "Last 7 Days": [moment().subtract(6, "days"), moment()],
                "Last 30 Days": [moment().subtract(29, "days"), moment()],
                "This Month": [moment().startOf("month"), moment().endOf("month")],
                "Last Month": [
                moment().subtract(1, "month").startOf("month"),
                moment().subtract(1, "month").endOf("month"),
                ],
            },
            },
            this.cb
        );

         this.cb(start, end);
    }
},

    mounted(){
        this.init()
    }
}

</script>
